import { render, staticRenderFns } from "./layout35.vue?vue&type=template&id=6079b726&"
import script from "./layout35.vue?vue&type=script&lang=ts&"
export * from "./layout35.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zfh/dev/targus-micor/targus-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6079b726')) {
      api.createRecord('6079b726', component.options)
    } else {
      api.reload('6079b726', component.options)
    }
    module.hot.accept("./layout35.vue?vue&type=template&id=6079b726&", function () {
      api.rerender('6079b726', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout35.vue"
export default component.exports